// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonUIRouterTransitionService } from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { DemoHasAccessService } from '@client/app/modules/demodata/services/demo-has-access.service';
import { SessionService } from '@monsido/core/session/session.service';

@Component({
    selector: 'accessibility-dashboard-pdf-doughnut',
    standalone: false,
    template: `
<div class="row">
  <div class="col-48 acc-pdf-doughnut-container">
    <mon-chart-doughnut
      [options]="options"
      [colors]="colors"
      [data]="doughnutData"
      [size]="'150'"
      [labels]="labels"
    >
    </mon-chart-doughnut>
  </div>
  <div class="col-48">
    <div class="text-link outer-t-small text-center col-48 cursor-pointer">
      <a (click)="goToPDF()" [attr.aria-label]="'Go to PDFs' | translate">
        <span class="fas fa-file-pdf" aria-hidden="true"></span>
        <span class="sr-only" translate>PDF</span>
        <span>{{title}} ({{totalPDF}})</span>
      </a>
    </div>
  </div>
</div>
    `,
})
export class AccessibilityDashboardPdfDoughnutComponent implements OnInit {
    @Input() data: any;
    @Input() type: any;
    @Input() typeAsText: any;

    title: any;
    colors: any;
    doughnutData: any;
    totalPDF: any;
    options: any;
    labels: any;

    constructor (
        private translateService: TranslateService,
        private stateService: StateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
        private pipeService: PipeService,
        private demoHasAccessService: DemoHasAccessService,
        private sessionService: SessionService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.title = this.pipeService.get('translateWithPlural')(
            this.translateService.getString('Pending PDF review'),
            this.data.unreviewed,
            this.translateService.getString('Pending PDF reviews'),
        );
        this.setupDoughnutChart();
    }

    setupDoughnutChart (): void {
        this.colors = ['#4dc0bd', '#dcdcdc'];
        this.doughnutData = [];
        this.totalPDF = this.data.unreviewed;
        this.doughnutData.push(this.data.reviewed);
        this.doughnutData.push(this.data.unreviewed || 1);
        const percentage = (this.data.reviewed / this.data.total) * 100 || 0;

        this.options = {
            maintainAspectRatio: true,
            centerText: {
                percentageLabel: this.pipeService.get('monNumber')(percentage / 100, '0.[00] %'),
                subLabel: this.translateService.getString('reviewed'),
                totalLabel: this.typeAsText,
                totalFontSize: 170,
                subFontSize: 170,
            },
            cutoutPercentage: 80,
            tooltips: {
                callbacks: {
                    label: (tooltipItem: any) => {
                        if (tooltipItem.index === 0) {
                            return this.getTooltipLabelText(this.data.reviewed, true);
                        }
                        return this.getTooltipLabelText(this.data.reviewed, false);
                    },
                },
            },
        };

        this.labels = [this.translateService.getString('Reviewed'), this.translateService.getString('Pending')];
    }

    goToPDF (): void {
        if (this.type === 'internal') {
            const hasDemoAccessToPdfAccessibility = this.demoHasAccessService.canAccessAccessibilityPDF();
            const customerHasAccessToPdfAccessibility = Boolean(this.sessionService.customer?.plan_traits?.clarity_pdf_accessibility);
            this.monUIRouterTransitionService.onTransitionFinished(
                () => {
                    if (hasDemoAccessToPdfAccessibility || customerHasAccessToPdfAccessibility) {
                        this.stateService.go('base.customer.domain.accessibility.internal_pdf_accessibility');
                    } else {
                        this.stateService.go('base.customer.domain.accessibility.internal_pdf');
                    }
                },
            );
        } else {
            this.monUIRouterTransitionService.onTransitionFinished(
                () => {
                    this.stateService.go('base.customer.domain.accessibility.external_pdf');
                },
            );
        }
    }

    getTooltipLabelText (pages: any, reviewed: any): any {
        pages = pages || 0;
        const scope = {
            pages: this.pipeService.get('monNumber')(pages),
        };
        const suffix = reviewed ? 'reviewed' : 'pending';
        const single = '1 page ' + suffix;
        const multi = '[[pages]] pages ' + suffix;
        return this.pipeService.get('translateWithPlural')(single, pages, multi, scope);
    }
}
